import { render, staticRenderFns } from "./NodesCosts.vue?vue&type=template&id=b4ec6882&scoped=true"
import script from "./NodesCosts.vue?vue&type=script&lang=js"
export * from "./NodesCosts.vue?vue&type=script&lang=js"
import style0 from "./NodesCosts.vue?vue&type=style&index=0&id=b4ec6882&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ec6882",
  null
  
)

export default component.exports